export const environment = {
    productiion: false,
    backend_url: "https://zedonpro.com"
}